import fr from 'facet-rest';
import { FDBodyText } from '@facet-wealth/design';
import { Richtext } from 'src/Packages/FacetDesign/Components/Richtext';
import { overrideReadOnly } from 'src/Packages/FacetRest/FacetDesignOverride';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride('taxDetailsLabel', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'md',
      color: 'textDisabled',
      hideLabel: true,
    },
  }, overrideReadOnly)
  .nameOverride('disclaimer', {
    _component: () => Richtext,
    _customProps: {
      richtext: true,
      color: 'textDisabled',
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride([
    'sourceAccountName', 'sourceMaskedAccountNumber', 'sourceAccountBalance', 'destinationAccountName',
    'destinationMaskedAccountNumber', 'destinationAccountBalance', 'amountAvailableForTransfer', 'image',
    'fullLiquidationConfirmationMessage', 'fullLiquidationConfirmationPrimaryActionLabel', 'fullLiquidationConfirmationTitle',
  ], {
    hidden: true,
  })
  .nameOverride('fullLiquidation', {
    ordinal: 0,
  });
